export default {
  props: {
    display: Boolean,
    title: String,
    message: String,
    icon: String,
    buttons: {
      type: Array,
      default: () => [],
    },
  },
};
